import { render, staticRenderFns } from "./WorkFlo.vue?vue&type=template&id=3c70d9e2&"
import script from "./WorkFlo.vue?vue&type=script&lang=js&"
export * from "./WorkFlo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports